import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import { action, computed } from "@ember/object"
import { inject as service } from "@ember/service"
import type { CardStack } from "@shared/models/card-stack"
import type { Planbook } from "@shared/models/planbook"
import reorderPositionedList from "cc-frontend/lib/reorder-positioned-list"
import type Dispatcher from "cc-frontend/services/dispatcher"
import { cloneDeep, find, isArray, isNil, map, min, reject, sortBy } from "lodash-es"

@tagName("")
export default class PlanbookWeeklyOrderDay extends Component {
  // args
  routine!: CardStack
  planbook!: Planbook

  @service dispatcher!: Dispatcher

  @computed("routine.attributes.cards.@each.attributes")
  get cardAttributes() {
    if (this.routine === null) return []
    return map(this.routine.attributes.cards, "attributes")
  }

  @computed("cardAttributes.@each.position")
  get sortedCards() {
    if (this.routine === null) return []
    this.cardAttributes // have to trigger the computed property above
    if (
      isArray(this.cardAttributes) !== true ||
      isNil(this.routine) ||
      isNil(this.routine.attributes)
    )
      return undefined
    return sortBy(this.routine.attributes.cards, "attributes.position")
  }

  @action
  reorderItems(newSections, model) {
    $(".js-add-day-card").css("opacity", 1)

    // We get a ton of false positives, so find out if the order changes
    // kinda odd, but we use _.min to find out if there's a false as
    // in a list of booleans, false is lower, so
    let existingCards = sortBy(this.routine.attributes.cards, "attributes.position")
    let thingsHaveNotMoved = min(
      map(newSections, (card, index) => {
        return existingCards[index] && existingCards[index].id === card.id
      })
    )
    if (thingsHaveNotMoved) return

    // Remove old section
    newSections = map(newSections, (card) => {
      if (card.id === model.id) {
        let movingSection = cloneDeep(card)
        movingSection.attributes.position = null
        return movingSection
      } else {
        return card
      }
    })
    let newCardPositions = reorderPositionedList(newSections)

    let positionDiffs = reject(newCardPositions, (tuple) => {
      let section = find(newSections, { id: tuple[0] })
      return section.attributes.position === tuple[1]
    })

    this.dispatcher.dispatch("ROUTINE_REORDER_SECTIONS", {
      cardStackId: this.routine.id,
      positionDiffs: positionDiffs,
      sectionBeingMoved: model,
      planbookId: this.planbook.id,
    })
  }
}
